var _ellipse, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPinterestBlack = function SvgPinterestBlack(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "pinterest-black-icon",
    width: 18.05,
    height: 18.057,
    viewBox: "0 0 18.05 18.057",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 9.025,
    cy: 9.029,
    rx: 9.025,
    ry: 9.029,
    transform: "translate(0 0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M158.4,133.9a3.5,3.5,0,0,0-3.8,3.271,2.012,2.012,0,0,0,1.087,2,.183.183,0,0,0,.267-.13c.025-.09.137-.325.162-.419a.253.253,0,0,0-.076-.292,1.336,1.336,0,0,1-.347-.964,2.415,2.415,0,0,1,2.556-2.6,1.994,1.994,0,0,1,2.209,2.032c0,1.509-.679,2.736-1.686,2.736a.777.777,0,0,1-.838-.96,11.188,11.188,0,0,0,.469-1.859.664.664,0,0,0-.715-.736c-.567,0-1.025.531-1.025,1.307a1.423,1.423,0,0,0,.162.74s-.574,2.516-.679,2.942a5.8,5.8,0,0,0-.014,1.989.071.071,0,0,0,.126.029,5.6,5.6,0,0,0,.96-1.715c.065-.231.375-1.437.375-1.437a1.486,1.486,0,0,0,1.3.57c1.708,0,2.866-1.455,2.866-3.505A3.153,3.153,0,0,0,158.4,133.9Z",
    transform: "translate(-149.019 -129.066)",
    fill: "#fff"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPinterestBlack, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pinterest-black.619db530.svg";
export { ForwardRef as ReactComponent };